import styles from "./style/answer_matrix.module.css";
import { useLanguage } from '../../functions/setGetLanguage';


const Answer_matrix = ({ choices, FunctionOnClick }) => {
  const { language } = useLanguage();

  return (
    <div className={styles.choices}>
      {choices.map((choice, i) => (
        <button
          key={i}
          className={styles.choiceButton}
          onClick={() => FunctionOnClick(choice)}
        >
          {choice[`text${language}`]}
        </button>
      ))}
    </div>
  );
};

export default Answer_matrix;
